import React from "react";
import { Link } from "react-router-dom";

import TrackIcon from '../../images/report_btn_illustrations/TrackIcon';
import { COPY_STRINGS } from '../../constants/translatedCopy';

export default function TrackingReportButton() {
  return (
    <Link to="/teacher/reports/type/tracking" className="trackingReportButton">
      <TrackIcon />
      <div className="trackingReportTextContainer">
        <span className="trackingReportText">
          {COPY_STRINGS.go_to_the}
        </span>
        <span className="reports-splash-block-header trackingReportSubText">
          {COPY_STRINGS.tracking_report}
        </span>
      </div>
    </Link>
  );
}